import Heronetworks from "components/Networks/HeroNetworks";
// import Listnetworks from "components/Client&Partner/ListNetworks";
import React from "react";

const Network = () => {
  return (
    <div>
      <Heronetworks />
      {/* <Listnetworks /> */}
    </div>
  );
};

export default Network;
